import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

export function FriendlyBoolean({
    children
}) {

    function friendlyBoolean(value) {
        if (value === true || value === "true") {
            return "Yes";
        }
        else if (!value) {
            return "No";
        }
        else {
            return value;
        }
    }

    return (
        <Fragment>{friendlyBoolean(children)}</Fragment>
    );
}

FriendlyBoolean.propTypes = {
    children: PropTypes.node.isRequired
};